import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { WebdealsState } from "../../../../models/state";

export const fulfilled = (actionType: keyof typeof AT) => {
    return `${actionType}_FULFILLED`;
};

const initialState = (): WebdealsState => ({
    deals: [],
});

const reducer = (state = initialState(), action: AnyAction): WebdealsState => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_FETCH_WEBDEALS):
            return {
                ...state,
                deals: action.payload.webdeals,
            };
        default:
            return state;
    }
};

export default reducer;
